import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import queryString from 'query-string';

// Store actions
import { setExperimentData } from '../../../actions/upload';


/**
 * This container is linked to the store `upload` key and it wraps the Examples component.
 * - Update a image url when the image upload is successfull.
 * - Reset any error since the examples are valid images
 * @extends {Component}
 */
class AbTestingContainer extends React.Component {
  /**
   * Attach all needed events to avoid drag and drop on uncontrolled areas
   */
  componentDidMount() {
    this.saveABTestingParams();
  }

  /**
   * It gets the ab testing params from query string and saves it in store
   */
  saveABTestingParams() {
    try {
      if (this.props.experimentData === '{}') {
        const parsed = queryString.parse(window.location.search);
        if ('expData' in parsed) {
          this.props.setExperimentData(window.atob(parsed.expData));
        }
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn(err);
    }
  }

  render() {
    return null;
  }
}

/**
 * Set the ExamplesContainer component props default values.
 * @type {Object}
 */
AbTestingContainer.defaultProps = {
  setExperimentData: () => {},
  experimentData: '{}',
};

/**
 * Declare the ExamplesContainer component PropTypes for better validation.
 * @type {Object}
 * @property {Function} setExperimentData        Callback that sets the drawing mode flag in the store.
 */
AbTestingContainer.propTypes = {
  setExperimentData: PropTypes.func,
  experimentData: PropTypes.string,
};

/**
 * It dispatches store action and returns an object of actions that will be merged with component props.
 * @param   {Object} dispatch bind action creators.
 * @returns {Object}
 */
const mapDispatchToProps = dispatch => ({
  setExperimentData: metadata => dispatch(setExperimentData(metadata)),

});

/**
 * Connect component with the store and actions.
 * @type {Object}
 */
export default connect(
  state => ({
    experimentData: state.upload.experimentData,
  }),
  mapDispatchToProps
)(AbTestingContainer);



// WEBPACK FOOTER //
// ./src/components/Upload/AbTestingContainer/AbTestingContainer.js